import axios from "axios";

import { apiDomain } from "../../store/constants";

const Dashboard = {
  kpi(payload) {
    return axios({
      url: `${apiDomain}api/dashboard/kpi`,
      method: "GET",
      params: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  budget(payload) {
    return axios({
      url: `${apiDomain}api/dashboard/budget`,
      method: "GET",
      params: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  budgetList(payload) {
    return axios({
      url: `${apiDomain}api/dashboard/budget-list`,
      method: "GET",
      params: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  progress(payload) {
    return axios({
      url: `${apiDomain}api/dashboard/progress`,
      method: "GET",
      params: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  budgetMap(payload) {
    return axios({
      url: `${apiDomain}api/dashboard/budget-map`,
      method: "GET",
      params: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  refresh(payload) {
    return axios({
      url: `${apiDomain}api/dashboard/refresh`,
      method: "POST",
      params: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  province() {
    return axios({
      url: `${apiDomain}api/province`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  region() {
    return axios({
      url: `${apiDomain}api/region`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  plans() {
    return axios({
      url: `${apiDomain}api/plan-master`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  building(payload) {
    return axios({
      url: `${apiDomain}api/dashboard/area-form/building`,
      method: "GET",
      params: payload,

    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
};

export default Dashboard;
